import { PopupMessageService } from "./../../../shared/message/services/message.service";
import { Router } from "@angular/router";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  ThemePalette,
} from "@angular/material";
import { forkJoin, Subscription } from "rxjs";
import { LocalService } from "src/app/core";
import { CreatePromotionService } from "src/app/core/services/create-promotion.service";
import * as XLSX from "xlsx";

@Component({
  selector: "app-create-promotions",
  templateUrl: "./create-promotions.component.html",
  styleUrls: ["./create-promotions.component.scss"],
})
export class CreatePromotionsComponent implements OnInit, AfterViewInit {
  pageno: number;
  questionType: string;
  promotionCreationIncomplete: boolean = true;
  initialAnsweredQues: number;
  @HostListener("window:beforeunload", ["$event"])
  OnBeforeUnloadEventHandler($event): void {
    if (this.promotionCreationIncomplete) {
      $event.returnValue = "";
      return;
    }
  }
  @HostListener("scroll", ["$event"])
  scrollHandler(event) {
    if (
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight
    ) {
      this.disableScrollBottom = true;
    } else if (event.target.scrollTop == 0) {
      this.disableScrollTop = true;
    } else {
      this.disableScrollTop = false;
      this.disableScrollBottom = false;
    }
  }
  @Output() promoCompleteStatusEvent = new EventEmitter<boolean>();
  @Output() promoSubmittedStatusEvent = new EventEmitter<boolean>();
  @ViewChild("scrollChatCard") scrollChatCardContainer: ElementRef;
  @ViewChild("fileInput") fileInput;
  combinedQuestionList: any = [];
  scrollContainer: any;
  progressVal: number = 0;
  userData: any;
  private subs: Subscription[] = [];
  selectedFieldList: any;
  possibleValuesList: any;
  customConfigData: any;
  budgetCapAmtForRegions: any = {};
  budgetCapAmtMain: any = [];
  dynamicQuestionIndex: number;
  incentiveAndPayoutQuestions: any = [];
  promotionEditOrCopy: boolean = false;
  inEligibleCountryValidated: boolean = true;
  passiveRecipientEmailVal: any;
  passiveRecipientEmailData: any;
  passiveEmailValidation: boolean = false;
  disableScrollTop: boolean = true;
  disableScrollBottom: boolean = false;
  disableSaveButton: boolean = false;
  dropdownSettings: any = {};
  showSpinner: boolean = false;
  spinnerColor: ThemePalette = "primary";
  americasRegions = ["USA", "CANADA", "LATAM"];

  constructor(
    private createPromotionService: CreatePromotionService,
    private dialog: MatDialog,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnInit() {
    this.subs.push(
      this.createPromotionService.getCiscoAdminData().subscribe((data) => {
        this.promotionEditOrCopy = data.editData || false;
      }),
      this.createPromotionService
        .getCreationPromotionData()
        .subscribe((result) => {
          this.possibleValuesList = result.possibleValues;
          this.customConfigData = result.customChallenge;
          this.combinedQuestionList = result.questions;
          //console.log(this.combinedQuestionList);
          this.setInitialQuestion();
          if (this.promotionEditOrCopy) {
            this.progressVal = Math.ceil(
              (this.combinedQuestionList.length /
                this.combinedQuestionList.length) *
                100
            );
          } else {
            this.progressVal = Math.ceil(
              (this.initialAnsweredQues /
                (this.combinedQuestionList.length - 1)) *
                100
            );
          }
          this.userData = LocalService.get("userProfile");
          this.setCountryIncludeExcludeData();
        })
    );
    this.dropdownSettings = {
      singleSelection: false,
      idField: "value",
      textField: "label",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      maxHeight: 200,
      noDataAvailablePlaceholderText: "No selections made.",
    };
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollContainer = this.scrollChatCardContainer.nativeElement;
      this.scrollToBottom();
    }, 0);
  }

  setInitialQuestion() {
    this.setBudgetAnswers();
    this.setQuestionNumbers();
    let criteria = this.combinedQuestionList[0];
    this.pageno = this.combinedQuestionList.indexOf(criteria);
    this.initialAnsweredQues = this.combinedQuestionList.indexOf(criteria);
    this.getQuestionContents();
  }

  setBudgetAnswers() {
    if (this.customConfigData.budgetCaps.length > 0) {
      this.customConfigData.budgetCaps.forEach((el) => {
        if (el.customBudgetCapType === "BUDGETCAP_REGIONAL") {
          this.budgetCapAmtForRegions[el.region] = el.amount;
        } else {
          this.budgetCapAmtMain[el.customBudgetCapType] = el.amount;
        }
      });
    }
  }

  setQuestionNumbers() {
    let questionNumber = 1;
    this.combinedQuestionList.forEach((question) => {
      if (
        question.identifier !== "TEMPLATED_PAYOUT" &&
        question.identifier !== "MAX_PAYOUT_PER_PO" &&
        question.identifier !== "MAX_PAYOUT_PER_CLAIM"
      ) {
        return (question.questionNumber = questionNumber++);
      }
    });
  }

  onSelectionChecked(isChecked) {
    if (
      this.combinedQuestionList[this.pageno].formFieldType == "CHECKBOX" &&
      this.combinedQuestionList[this.pageno].identifier == "regions"
    ) {
      !isChecked && this.removeSelectedCountryLists();
    }
  }

  updateBudgetRegionSelection() {
    let budgetCapGroups = {};
    if (
      this.combinedQuestionList[this.pageno].formFieldType == "CHECKBOX" &&
      this.combinedQuestionList[this.pageno].identifier == "regions"
    ) {
      if (
        this.customConfigData[this.combinedQuestionList[this.pageno].identifier]
          .length
      ) {
        this.customConfigData[
          this.combinedQuestionList[this.pageno].identifier
        ].forEach((region) => {
          budgetCapGroups[region] = this.budgetCapAmtForRegions[region] || null;
        });
      }
      this.budgetCapAmtForRegions = budgetCapGroups;
    }
    if (this.customConfigData.budgetCaps.length > 0) {
      let updatedBudgetCaps = this.customConfigData.budgetCaps.filter(
        (budget) => {
          if (budget.customBudgetCapType === "BUDGETCAP_REGIONAL") {
            return Object.keys(this.budgetCapAmtForRegions).includes(
              budget.region
            );
          } else {
            return budget;
          }
        }
      );
      this.customConfigData.budgetCaps = updatedBudgetCaps;
    }
  }

  getQuestionContents(finalPage?) {
    if (finalPage) {
      this.questionType = "finalReview";
      return;
    }
    let fieldType = this.combinedQuestionList[this.pageno].identifier;
    if (fieldType == "regions") {
      fieldType = fieldType.toUpperCase();
    }
    this.selectedFieldList =
      fieldType != null ? this.possibleValuesList[fieldType] : null;
    if (fieldType == "quarter") {
      this.possibleValuesList.fiscalYear.forEach((data) => {
        if (data.value == this.customConfigData.fiscalYear) {
          this.selectedFieldList = data.possibleValues;
        }
      });
    }
    if (fieldType === "COUNTRY_INCLUDE" || fieldType === "COUNTRY_EXCLUDE") {
      let dropdownData = [];
      this.possibleValuesList.REGION_COUNTRY_MAPPING.forEach((regionData) => {
        this.customConfigData["regions"].forEach((region) => {
          if (region === regionData.value) {
            dropdownData = [...dropdownData, ...regionData.possibleValues];
          }
        });
      });
      this.selectedFieldList = dropdownData;
    }
    //if (fieldType == 'startDate') {
    //if(this.customConfigData['startDate'] == null) {
    // this.possibleValuesList.fiscalYear.forEach(data => {
    //   if(data.value == this.customConfigData.fiscalYear) {
    //     data.possibleValues.forEach(quarterData => {
    //       if(quarterData.value == this.customConfigData.quarter) {
    //         quarterData.possibleValues.filter(dateData => {
    //           if (dateData.label == "Start Date") {
    //             this.customConfigData['startDate'] =  dateData.value
    //           };
    //           if (dateData.label == "End Date") {
    //             this.customConfigData['endDate'] = dateData.value
    //           };
    //         });
    //       };
    //     });
    //   };
    // });
    //};
    //};
    // if (fieldType == 'quickClaimingDeadline' && !this.customConfigData['quickClaimingDeadline']) {
    //   let quickClaimingDeadlineDate = new Date(this.customConfigData['endDate']);
    //   quickClaimingDeadlineDate.setDate(quickClaimingDeadlineDate.getDate()+ 60);
    //   this.customConfigData['quickClaimingDeadline'] = quickClaimingDeadlineDate;
    // }
    // if (fieldType == 'popClaimingDeadline' && !this.customConfigData['popClaimingDeadline']) {
    //   let popClaimingDeadlineDate = new Date(this.customConfigData['endDate']);
    //   popClaimingDeadlineDate.setDate(popClaimingDeadlineDate.getDate()+ 30);
    //   this.customConfigData['popClaimingDeadline'] = popClaimingDeadlineDate;
    // }
    if (fieldType == "TRAINING_ACTIVITY") {
      this.showSpinner = true;
      let startDate = new Date(this.customConfigData["startDate"]);
      let endDate = new Date(this.customConfigData["endDate"]);
      let formattedStartDate =
        startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);
      let formattedEndDate =
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2);
      let regions = this.customConfigData["regions"];
      //console.log(this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex])
      this.subs.push(
        this.createPromotionService
          .getTrainingActivityData(
            formattedStartDate,
            formattedEndDate,
            regions
          )
          .subscribe(
            (data) => {
              this.selectedFieldList = data.ACTIVITY_CHALLENGES;
              this.showSpinner = false;
            },
            (err) => {
              this.showSpinner = false;
            }
          )
      );
    }
    if (
      this.selectedFieldList == null &&
      this.combinedQuestionList[this.pageno].formFieldType == "CHECKBOX"
    ) {
      let dropdownData = [];
      if (this.combinedQuestionList[this.pageno].info == "STATIC") {
        this.customConfigData[
          this.combinedQuestionList[this.pageno].identifier
        ].forEach((val) => {
          dropdownData.push({ value: val.toString(), label: val.toString() });
        });
      } else {
        if (
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.length > 0
        ) {
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.forEach((val) => {
            dropdownData.push({ value: val.toString(), label: val.toString() });
          });
        }
      }
      this.selectedFieldList = dropdownData;
    }
    if (this.combinedQuestionList[this.pageno].formFieldType == "RADIOBUTTON") {
      this.customConfigData[this.combinedQuestionList[this.pageno].identifier] =
        this.customConfigData[
          this.combinedQuestionList[this.pageno].identifier
        ].toString();
    }
    if (this.combinedQuestionList[this.pageno].type === "TEMPLATED") {
      this.incentiveAndPayoutQuestions = [
        this.combinedQuestionList[this.pageno],
        this.combinedQuestionList[this.pageno + 1],
        this.combinedQuestionList[this.pageno + 2],
        this.combinedQuestionList[this.pageno + 3],
      ];
      this.questionType = "GROUP";
      return;
    }
    if (this.combinedQuestionList[this.pageno].info === "BUDGET_CAP") {
      if (
        this.combinedQuestionList[this.pageno].identifier ===
        "BUDGETCAP_REGIONAL"
      ) {
        this.questionType = this.combinedQuestionList[this.pageno].identifier;
      } else {
        this.questionType = "BUDGET-TEXT";
      }
      return;
    }
    if (
      this.combinedQuestionList[this.pageno].identifier ==
      "contraFundingApproverEmails"
    ) {
      this.passiveRecipientEmailVal = "contraFundingPassiveRecipientEmails";
      this.passiveRecipientEmailData =
        this.customConfigData["contraFundingPassiveRecipientEmails"];
    }
    if (
      this.combinedQuestionList[this.pageno].identifier ==
      "productApproverEmails"
    ) {
      this.passiveRecipientEmailVal = "productPassiveRecipientEmails";
      this.passiveRecipientEmailData =
        this.customConfigData["productPassiveRecipientEmails"];
    }
    if (
      this.combinedQuestionList[this.pageno].identifier ==
      "challengeApproverEmails"
    ) {
      this.passiveRecipientEmailVal = "challengePassiveRecipientEmails";
      this.passiveRecipientEmailData =
        this.customConfigData["challengePassiveRecipientEmails"];
    }
    this.questionType = this.combinedQuestionList[this.pageno].formFieldType;
  }

  moveToNextPage(pageno, pageName?, event?) {
    console.log('movenext evt',pageno,pageName,event)
    if (pageName == "criteriaGroup") {
      //this.customConfigData.challengeCriteria.criterias[0]=event
       this.setCriteriaGroup(event);
    }
    if (pageName == "budget-single") {
      this.setBudgetNonRegionGroup();
    }
    if (pageName == "budget-group") {
      this.setBudgetRegionGroup();
    }
    if (
      this.combinedQuestionList[this.pageno].formFieldType == "TEXTAREA_LIST"
    ) {
      if (
        this.combinedQuestionList[this.pageno].identifier == "approverEmails" ||
        this.combinedQuestionList[this.pageno].identifier ==
          "contraFundingApproverEmails" ||
        this.combinedQuestionList[this.pageno].identifier ==
          "productApproverEmails" ||
        this.combinedQuestionList[this.pageno].identifier ==
          "challengeApproverEmails"
      ) {
        this.customConfigData[this.passiveRecipientEmailVal] =
          this.passiveRecipientEmailData || [];
        this.setEmailData();
        this.setPassiveEmailData();
        if (
          !this.combinedQuestionList[this.pageno].emailValidationSuccess ||
          this.passiveEmailValidation
        ) {
          return;
        }
      } else {
        this.setCountryValidatedData();
        if (!this.inEligibleCountryValidated) {
          return;
        }
      }
    }
    //console.log(this.customConfigData);
    if (
      this.combinedQuestionList[this.pageno].type === "TEMPLATED" &&
      this.combinedQuestionList[this.pageno + 1].type === "TEMPLATED" &&
      this.combinedQuestionList[this.pageno + 3].type === "TEMPLATED"
    ) {
      this.pageno = pageno + 4;
    } else {
      this.pageno = pageno + 1;
    }
    this.initialAnsweredQues =
      this.pageno > this.initialAnsweredQues
        ? this.pageno
        : this.initialAnsweredQues;
    if (this.pageno === this.combinedQuestionList.length) {
      this.getQuestionContents(true);
      return;
    }
    if (this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED") {
      this.dynamicQuestionIndex =
        this.customConfigData.challengeCriteria.criterias.findIndex(
          (criteria) => {
            if (criteria.type != "GROUP") {
              return (
                criteria.questionInfo.questionIdentifier ===
                this.combinedQuestionList[this.pageno].identifier
              );
            }
          }
        );
    }
    if (
      this.combinedQuestionList[this.pageno].info === "STATIC" &&
      this.combinedQuestionList[this.pageno].identifier === "acronym"
    ) {
      if (this.customConfigData.acronym == null) {
        let challengeName = "";
        this.customConfigData.name
          .split(" ")
          .filter((e) => e.trim())
          .forEach((x) => {
            challengeName += x.charAt(0).toUpperCase();
          });
        this.customConfigData.acronym =
          "SC-" +
          challengeName +
          "-" +
          this.customConfigData.quarter.slice(-1) +
          this.customConfigData.fiscalYear.slice(-2);
      }
    }
    this.getQuestionContents();
    setTimeout(() => {
      this.scrollToBottom();
      if (this.promotionEditOrCopy) {
        this.progressVal = Math.ceil(
          (this.combinedQuestionList.length /
            this.combinedQuestionList.length) *
            100
        );
      } else {
        this.progressVal = Math.ceil(
          (this.initialAnsweredQues / (this.combinedQuestionList.length - 1)) *
            100
        );
      }
    }, 0);
  }

  moveToPreviousPage(pageno, inputStatus, pageName?, event?) {
    if (pageName == "criteriaGroup") {
      this.setCriteriaGroup(event);
    }
    if (this.questionType === "finalReview") {
      this.pageno = pageno - 1;
      this.getQuestionContents();
      return;
    }
    if (this.initialAnsweredQues === pageno && !inputStatus) {
      this.initialAnsweredQues = this.initialAnsweredQues + 1;
    }
    if (
      this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED" &&
      this.combinedQuestionList[this.pageno - 1].type === "TEMPLATED" &&
      this.combinedQuestionList[this.pageno - 3].type === "TEMPLATED"
    ) {
      this.pageno = pageno - 4;
    } else {
      this.pageno = pageno - 1;
    }
    if (this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED") {
      this.dynamicQuestionIndex =
        this.customConfigData.challengeCriteria.criterias.findIndex(
          (criteria) => {
            if (criteria.type != "GROUP") {
              return (
                criteria.questionInfo.questionIdentifier ===
                this.combinedQuestionList[this.pageno].identifier
              );
            }
          }
        );
    }
    this.getQuestionContents();
    setTimeout(() => {
      this.scrollToBottom();
      if (this.promotionEditOrCopy) {
        this.progressVal = Math.ceil(
          (this.combinedQuestionList.length /
            this.combinedQuestionList.length) *
            100
        );
      } else {
        this.progressVal = Math.ceil(
          (this.initialAnsweredQues / (this.combinedQuestionList.length - 1)) *
            100
        );
      }
    }, 0);
  }

  upload() {
    document.getElementById("getFile").click();
  }

  getFile(eve) {
    //console.log(eve);
    let data;
    const target: DataTransfer = <DataTransfer>eve.target;
    if (target.files.length !== 1) {
      throw new Error("Cannot use multiple files");
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      //adding filename to json
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].uploadedFileName = target.files[0].name;

      /* save data */
      data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      //console.log(data); // Data will be logged in array format containing objects
      this.fileInput.nativeElement.value = "";
      this.setDataInDropDown(data);
    };
  }

  setDataInDropDown(data) {
    let columnName = Object.keys(data[0])[0];
    let dropdownData = [];
    let selectedValData = [];
    data.forEach((val) => {
      dropdownData.push({
        value: val[columnName].toString(),
        label: val[columnName].toString(),
      });
      selectedValData.push(val[columnName].toString());
    });
    this.selectedFieldList = dropdownData;
    this.customConfigData.challengeCriteria.criterias[
      this.dynamicQuestionIndex
    ].acceptedValues = selectedValData;
    let fieldType = this.combinedQuestionList[this.pageno].identifier;
    this.possibleValuesList[fieldType] = dropdownData;
  }

  checkPromoCreationStatus(value: boolean = false) {
    this.promotionCreationIncomplete = value;
    this.promoCompleteStatusEvent.emit(value);
  }

  getMultiSelectVals(item) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (criteria.questionInfo.questionIdentifier === item.identifier) {
          return criteria;
        }
      }
    );
    if (
      item.identifier === "COUNTRY_INCLUDE" ||
      item.identifier === "COUNTRY_EXCLUDE"
    ) {
      return selectedVal.acceptedValues.length <= 5
        ? selectedVal.acceptedValues.map((x) => x.label).toString()
        : selectedVal.acceptedValues.length + " Records";
    }
    return selectedVal.acceptedValues.length <= 5
      ? selectedVal.acceptedValues.toString()
      : selectedVal.acceptedValues.length + " Records";
  }

  getMultiSelectValsInSummary(item) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (criteria.questionInfo.questionIdentifier === item.identifier) {
          return criteria;
        }
      }
    );
    return selectedVal.acceptedValues;
  }

  openListContent(listData) {
    const dialogRef = this.dialog.open(DataListDialog, {
      width: "514px",
      data: listData,
    });
  }

  getSelectedDates() {
    return `Start Date - ${new Date(
      this.customConfigData["startDate"]
    ).toDateString()}<br>End Date - ${new Date(
      this.customConfigData["endDate"]
    ).toDateString()}`;
  }

  getSelectedDate(item) {
    return new Date(this.customConfigData[item.identifier]).toDateString();
  }

  scrollToBottom(): void {
    if (this.combinedQuestionList[this.pageno] != null) {
      let el = document.getElementById(
        "chat" + this.combinedQuestionList[this.pageno].identifier
      );
      this.scrollContainer.scroll({
        top: el.offsetTop - 200,
        behavior: "smooth",
      });
    }
  }

  navigateToSelectedQuestion(questionList) {
    this.pageno = this.combinedQuestionList.indexOf(questionList);
    if (this.combinedQuestionList[this.pageno].type === "NON_TEMPLATED") {
      this.dynamicQuestionIndex =
        this.customConfigData.challengeCriteria.criterias.findIndex(
          (criteria) => {
            if (criteria.type != "GROUP") {
              return (
                criteria.questionInfo.questionIdentifier ===
                this.combinedQuestionList[this.pageno].identifier
              );
            }
          }
        );
    }
    this.getQuestionContents();
  }

  removeSelectedCountryLists() {
    let includeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge) => {
          return challenge.field == "COUNTRY_INCLUDE";
        }
      );
    if (
      includeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[includeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues = [];
    }
    let excludeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge) => {
          return challenge.field == "COUNTRY_EXCLUDE";
        }
      );
    if (
      excludeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[excludeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues = [];
    }
  }

  setCountryIncludeExcludeData() {
    let dropdownData = [];
    this.possibleValuesList.REGION_COUNTRY_MAPPING.forEach((regionData) => {
      this.customConfigData["regions"].forEach((region) => {
        if (region === regionData.value) {
          dropdownData = [...dropdownData, ...regionData.possibleValues];
        }
      });
    });
    let includeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge) => {
          return challenge.field == "COUNTRY_INCLUDE";
        }
      );
    if (
      includeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[includeIndex]
        .acceptedValues.length > 0
    ) {
      let countryListData = [];
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues.forEach((val) => {
        dropdownData.forEach((country) => {
          if ((val.value || val) === country.value) {
            countryListData.push(country);
          }
        });
      });
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues = countryListData;
    }
    let excludeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge) => {
          return challenge.field == "COUNTRY_EXCLUDE";
        }
      );
    if (
      excludeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[excludeIndex]
        .acceptedValues.length > 0
    ) {
      let countryListData = [];
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues.forEach((val) => {
        dropdownData.forEach((country) => {
          if ((val.value || val) === country.value) {
            countryListData.push(country);
          }
        });
      });
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues = countryListData;
    }
  }

  setIncludeAndExcludeCountryData() {
    let includeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge) => {
          return challenge.field == "COUNTRY_INCLUDE";
        }
      );
    if (
      includeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[includeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues = this.customConfigData.challengeCriteria.criterias[
        includeIndex
      ].acceptedValues.map((x) => x.value);
    }
    let excludeIndex =
      this.customConfigData.challengeCriteria.criterias.findIndex(
        (challenge) => {
          return challenge.field == "COUNTRY_EXCLUDE";
        }
      );
    if (
      excludeIndex >= 0 &&
      this.customConfigData.challengeCriteria.criterias[excludeIndex]
        .acceptedValues.length > 0
    ) {
      this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues = this.customConfigData.challengeCriteria.criterias[
        excludeIndex
      ].acceptedValues.map((x) => x.value);
    }
  }

  submitSalesChallenge() {
    console.log('customconfigdata',this.customConfigData)
    this.setIncludeAndExcludeCountryData();
    this.subs.push(
      this.createPromotionService
        .submitCustomSalesChallenge(this.customConfigData)
        .subscribe(
          (response) => {
            //console.log(response);
            if (response != "") {
              this.promoSubmittedStatusEvent.emit(true);
              this.popupMessageService.showSuccess(
                "Created Challenge Successfully",
                "success"
              );
              this.disableSaveButton = false;
            }
          },
          (err) => {
            if (err !== null) {
              this.popupMessageService.showError(
                "Something went wrong",
                "error"
              );
              this.disableSaveButton = false;
            }
          }
        )
    );
  }

  createPromoFormSubmit(submissionType) {
    this.disableSaveButton = true;
    // if(submissionType == 'SUBMIT') {
    //   this.customConfigData.status =  'PENDING_APPROVAL';
    // }
    if (
      this.budgetCapAmtMain[
        this.combinedQuestionList[this.pageno - 1].identifier
      ] != null
    ) {
      let index = this.customConfigData.budgetCaps.findIndex((budget) => {
        return (
          budget.customBudgetCapType ==
          this.combinedQuestionList[this.pageno - 1].identifier
        );
      });
      if (index > -1) {
        this.customConfigData.budgetCaps[index].amount =
          this.budgetCapAmtMain[
            this.combinedQuestionList[this.pageno - 1].identifier
          ] || null;
      } else {
        this.customConfigData.budgetCaps.push({
          amount:
            this.budgetCapAmtMain[
              this.combinedQuestionList[this.pageno - 1].identifier
            ] || null,
          customBudgetCapType:
            this.combinedQuestionList[this.pageno - 1].identifier,
        });
      }
    }
    this.customConfigData["autoDistPointsToCompanyOverride"] =
      this.customConfigData["autoDistPointsToCompanyOverride"] === "true"
        ? true
        : false;
    if (submissionType == "SUBMIT") {
      const dialogRef = this.dialog.open(ConfirmationDialogSubmitPromo, {
        width: "514px",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.event) {
          this.submitSalesChallenge();
        } else {
          //console.log(this.customConfigData);
          // this.customConfigData.status=prevStatus;
        }
      });
    } else {
      this.submitSalesChallenge();
    }
  }

  checkBudgetRegionData() {
    if (
      Object.keys(this.budgetCapAmtForRegions).length &&
      Object.values(this.budgetCapAmtForRegions).some((x) => x == null)
    ) {
      return true;
    } else {
      return false;
    }
  }

  getBudgetForRegions() {
    let text = "";

    for (let property in this.budgetCapAmtForRegions) {
      text += `${property} - ${this.budgetCapAmtForRegions[property]}<br>`;
    }
    return text;
  }

  setCriteriaGroup(event) {
    console.log('setCriteriaGroup event',event)
   this.customConfigData.challengeCriteria.criterias= this.customConfigData.challengeCriteria.criterias.map((obj) => {
      if (obj.type == "GROUP") {
        return event;

       
       
      }else{
         return obj;
      }
  
    });
    console.log('setCriteriaGroup challengeCriteria',this.customConfigData.challengeCriteria.criterias)
  }

  setDateValues() {
    if (
      this.combinedQuestionList[this.pageno].identifier == "fiscalYear" ||
      this.combinedQuestionList[this.pageno].identifier == "quarter"
    ) {
      this.possibleValuesList.fiscalYear.forEach((data) => {
        if (data.value == this.customConfigData.fiscalYear) {
          data.possibleValues.forEach((quarterData) => {
            if (quarterData.value == this.customConfigData.quarter) {
              quarterData.possibleValues.filter((dateData) => {
                if (dateData.label == "Start Date") {
                  this.customConfigData["startDate"] = dateData.value;
                }
                if (dateData.label == "End Date") {
                  this.customConfigData["endDate"] = dateData.value;
                }
              });
            }
          });
        }
      });
      let challengeName = "";
      this.customConfigData.name
        .split(" ")
        .filter((e) => e.trim())
        .forEach((x) => {
          challengeName += x.charAt(0).toUpperCase();
        });
      this.customConfigData.acronym =
        "SC-" +
        challengeName +
        "-" +
        (this.customConfigData.quarter
          ? this.customConfigData.quarter.slice(-1)
          : "") +
        (this.customConfigData.fiscalYear
          ? this.customConfigData.fiscalYear.slice(-2)
          : "");
      let quickClaimingDeadlineDate = new Date(
        this.customConfigData["endDate"]
      );
      quickClaimingDeadlineDate.setDate(
        quickClaimingDeadlineDate.getDate() + 60
      );
      this.customConfigData["quickClaimingDeadline"] =
        quickClaimingDeadlineDate;
      let popClaimingDeadlineDate = new Date(this.customConfigData["endDate"]);
      popClaimingDeadlineDate.setDate(popClaimingDeadlineDate.getDate() + 30);
      this.customConfigData["popClaimingDeadline"] = popClaimingDeadlineDate;
    }
  }

  onEndDateChange(event) {
    this.customConfigData["endDate"] = event;
    let quickClaimingDeadlineDate = new Date(this.customConfigData["endDate"]);
    quickClaimingDeadlineDate.setDate(quickClaimingDeadlineDate.getDate() + 60);
    this.customConfigData["quickClaimingDeadline"] = quickClaimingDeadlineDate;
    let popClaimingDeadlineDate = new Date(this.customConfigData["endDate"]);
    popClaimingDeadlineDate.setDate(popClaimingDeadlineDate.getDate() + 30);
    this.customConfigData["popClaimingDeadline"] = popClaimingDeadlineDate;
  }

  setAcronymOnNameChange() {
    if (this.combinedQuestionList[this.pageno].identifier == "name") {
      let challengeName = "";
      this.customConfigData.name
        .split(" ")
        .filter((e) => e.trim())
        .forEach((x) => {
          challengeName += x.charAt(0).toUpperCase();
        });
      this.customConfigData.acronym =
        "SC-" +
        challengeName +
        "-" +
        (this.customConfigData.quarter
          ? this.customConfigData.quarter.slice(-1)
          : "") +
        (this.customConfigData.fiscalYear
          ? this.customConfigData.fiscalYear.slice(-2)
          : "");
    }
  }

  setBudgetNonRegionGroup() {
    let index = this.customConfigData.budgetCaps.findIndex((budget) => {
      return (
        budget.customBudgetCapType ==
        this.combinedQuestionList[this.pageno].identifier
      );
    });
    if (index > -1) {
      this.customConfigData.budgetCaps[index].amount =
        this.budgetCapAmtMain[
          this.combinedQuestionList[this.pageno].identifier
        ] || null;
    } else {
      this.customConfigData.budgetCaps.push({
        amount:
          this.budgetCapAmtMain[
            this.combinedQuestionList[this.pageno].identifier
          ] || null,
        customBudgetCapType: this.combinedQuestionList[this.pageno].identifier,
      });
    }
  }

  setBudgetRegionGroup() {
    Object.entries(this.budgetCapAmtForRegions).forEach(([key, value]) => {
      let index = this.customConfigData.budgetCaps.findIndex((budget) => {
        if (budget.hasOwnProperty("region")) {
          return budget.region == key;
        }
      });
      if (index > -1) {
        this.customConfigData.budgetCaps[index].amount = value || null;
      } else {
        this.customConfigData.budgetCaps.push({
          amount: value || null,
          customBudgetCapType: "BUDGETCAP_REGIONAL",
          region: key,
        });
      }
    });
  }

  setCriteriaData(criteria, value) {
    if (value == "") {
      criteria.acceptedValues.length = 0;
      return;
    }
    if (criteria.acceptedValues.length) {
      criteria.acceptedValues[0] = value;
    } else {
      criteria.acceptedValues.push(value);
    }
  }

  setEmailData() {
    let emailValues =
      typeof this.customConfigData[
        this.combinedQuestionList[this.pageno].identifier
      ] == "object"
        ? (this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ] = this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ]
            .join(",")
            .split(","))
        : this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ].split(/[,;^\s*$]+/);
    this.combinedQuestionList[this.pageno].emailValidationSuccess =
      this.verifyEmailValues(emailValues);
    if (this.combinedQuestionList[this.pageno].emailValidationSuccess) {
      this.customConfigData[this.combinedQuestionList[this.pageno].identifier] =
        [];
      emailValues.forEach(
        (emailID) =>
          emailID &&
          this.customConfigData[
            this.combinedQuestionList[this.pageno].identifier
          ].push(emailID)
      );
    }
    //console.log(this.customConfigData[this.combinedQuestionList[this.pageno].identifier])
  }

  setCountryValidatedData() {
    if (
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues == "" &&
      !this.combinedQuestionList[this.pageno].isRequired
    ) {
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues = [];
      this.inEligibleCountryValidated = true;
      return;
    }
    let ineligibleCountries =
      typeof this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues == "object"
        ? (this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues = this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues
            .join(",")
            .split(","))
        : this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.split(/[,;^\s*$]+/);
    this.inEligibleCountryValidated =
      this.verifyCountryValues(ineligibleCountries);
    if (this.inEligibleCountryValidated) {
      this.customConfigData.challengeCriteria.criterias[
        this.dynamicQuestionIndex
      ].acceptedValues = [];
      ineligibleCountries.forEach(
        (country) =>
          country &&
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.push(country)
      );
    }
    //console.log(this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex].acceptedValues)
  }

  verifyEmailValues(emailValues) {
    let emailVerificationStatus;
    let regex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    emailVerificationStatus = emailValues.every((email) => {
      return regex.test(email);
    });
    return emailVerificationStatus;
  }

  verifyCountryValues(countryList) {
    let countryVerificationStatus;
    let regex = /[A-Za-z]/;
    countryList.forEach((email) => {
      if (regex.test(email)) {
        countryVerificationStatus = true;
      } else {
        countryVerificationStatus = false;
      }
    });
    return countryVerificationStatus;
  }

  getEmailIds(questionInfo) {
    if (typeof this.customConfigData[questionInfo.identifier] == "object") {
      return this.customConfigData[questionInfo.identifier]
        .join(",")
        .toString();
    } else {
      return this.customConfigData[questionInfo.identifier];
    }
  }

  getTextAreaContent(questionInfo) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (
          criteria.questionInfo.questionIdentifier === questionInfo.identifier
        ) {
          return criteria;
        }
      }
    );
    return selectedVal.acceptedValues.toString();
  }

  getIncentiveAndPayoutData() {
    let incentiveAndPayout =
      this.customConfigData.challengeCriteria.criterias.filter((obj) => {
        if (obj.type == "GROUP") {
          return obj;
        }
      });
    return incentiveAndPayout[0];
  }

  checkSpecializationValue() {
    let returnVal = false;
    if (this.combinedQuestionList[this.pageno].identifier == "BEGEOID") {
      this.customConfigData.challengeCriteria.criterias.forEach((criteria) => {
        if (criteria.field == "PARTNER_SPECIALIZATION") {
          if (
            !!criteria.acceptedValues[0] &&
            criteria.acceptedValues[0].toLowerCase() != "all"
          ) {
            returnVal = true;
          } else {
            returnVal = false;
          }
        }
      });
    }
    return returnVal;
  }

  showDownloadExcelFormatDialog(identifier) {
    const dialogRef = this.dialog.open(DownloadFileFormatDialog, {
      width: "514px",
      data: identifier,
    });
    dialogRef.afterClosed().subscribe((result) => {
      // if (result.event) {
      // } else {
      // }
    });
  }

  setPassiveEmailData() {
    let emailValues;
    let regex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    if (
      this.customConfigData[this.passiveRecipientEmailVal] == null ||
      this.customConfigData[this.passiveRecipientEmailVal].length === 0
    ) {
      this.passiveEmailValidation = false;
      return;
    }
    typeof this.customConfigData[this.passiveRecipientEmailVal] == "object"
      ? (emailValues = this.customConfigData[this.passiveRecipientEmailVal])
      : (emailValues =
          this.customConfigData[this.passiveRecipientEmailVal].split(
            /[,;^\s*$]+/
          ));
    let passiveEmailTest = emailValues.every((email) => {
      return regex.test(email);
    });
    if (passiveEmailTest) {
      this.passiveEmailValidation = false;
      this.customConfigData[this.passiveRecipientEmailVal] = [];
      emailValues.forEach(
        (emailID) =>
          emailID &&
          this.customConfigData[this.passiveRecipientEmailVal].push(emailID)
      );
    } else {
      this.passiveEmailValidation = true;
    }
  }

  scrollToTopLayout() {
    this.scrollChatCardContainer.nativeElement.scrollTo({
      left: 0,
      top: 0,
      behavior: "smooth",
    });
  }

  scrollToBottomLayout() {
    this.scrollChatCardContainer.nativeElement.scrollTo({
      left: 0,
      top: this.scrollChatCardContainer.nativeElement.scrollHeight,
      behavior: "smooth",
    });
  }

  clearSelectionOnNone(value, selected) {
    if (
      this.combinedQuestionList[this.pageno].identifier == "TRAINING_ACTIVITY"
    ) {
      //console.log(value);
      if (value.label == "NONE" && selected) {
        this.customConfigData.challengeCriteria.criterias[
          this.dynamicQuestionIndex
        ].acceptedValues = ["NONE"];
        this.customConfigData["activityChallengeCompletionIsRequired"] = false;
      } else {
        let index =
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.indexOf("NONE");
        if (index !== -1) {
          this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues = this.customConfigData.challengeCriteria.criterias[
            this.dynamicQuestionIndex
          ].acceptedValues.filter((x) => x != "NONE");
          // console.log(this.customConfigData.challengeCriteria.criterias[this.dynamicQuestionIndex].acceptedValues)
        }
      }
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  getAmericasRegions() {
    return this.americasRegions.filter((r) =>
      this.customConfigData.regions.includes(r)
    );
  }

  getOtherRegions() {
    return this.customConfigData.regions.filter(
      (r) => !this.americasRegions.includes(r)
    );
  }

  getAmericasTotal() {
    return this.getAmericasRegions().reduce(
      (sum, r) => sum + (this.budgetCapAmtForRegions[r] || 0),
      0
    );
  }

  getAllRegionsTotal() {
    return this.customConfigData.regions.reduce(
      (sum, r) => sum + (this.budgetCapAmtForRegions[r] || 0),
      0
    );
  }

  hasOnlyAmericas() {
    const regions = this.customConfigData.regions || [];
    return regions.every((r) => this.americasRegions.includes(r));
  }
}

@Component({
  selector: "confirmation-dialog-submit-promo",
  templateUrl: "./confirmation-dialog-submit-promo.html",
  styleUrls: ["./confirmation-dialog-submit-promo.scss"],
})
export class ConfirmationDialogSubmitPromo {
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogSubmitPromo>) {}

  confirmNavigation(flag) {
    this.dialogRef.close({ event: flag });
  }
}

@Component({
  selector: "download-file-format-dialog",
  templateUrl: "./download-file-format-dialog.html",
  styleUrls: ["./download-file-format-dialog.scss"],
})
export class DownloadFileFormatDialog {
  constructor(
    public dialogRef: MatDialogRef<DownloadFileFormatDialog>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  downloadExcel() {
    let columnData = [];
    if (this.data === "BEGEOID") {
      columnData = [["BEGEOID"]];
    } else if (this.data === "END_CUSTOMER_ID") {
      columnData = [["END CUSTOMER GLOBAL HQ ID"]];
    } else if (this.data === "INDIVIDUAL_PRODUCT_LIST") {
      columnData = [["PRODUCT", "TYPE", "PAYOUT"]];
    } else if (this.data === "PRODUCT_LIST") {
      columnData = [["PRODUCT"]];
    } else if (this.data === "EXCEL_MERGE") {
      columnData = [["PRODUCT", "TYPE"]];
    } else if (this.data === "PRODUCT_SKUS") {
      columnData = [["PRODUCT SKUS"]];
    } else if (this.data === "PRODUCT_FAMILIES") {
      columnData = [["PRODUCT FAMILIES"]];
    } else if (this.data === "TARGETS_INDIVIDUAL") {
      columnData = [["USER", "TARGET"]];
    } else if (this.data === "TARGETS_COMPANY") {
      columnData = [["BEGEOID", "TARGET"]];
    } else if (this.data === "PARTICIPANT_INDIVIDUAL") {
      columnData = [["USERIDS"]];
    } else if (this.data === "PARTICIPANT_COMPANY") {
      columnData = [["BEGEOIDS"]];
    } else if (this.data === "UPLOAD_COMPLETION") {
      columnData = [["CCOID", "Date of completion (MM/DD/YYYY)"]];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push("First");
    workbook.Sheets["First"] = worksheet;
    let xlsbin = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "binary",
    });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: "application/octet-stream" });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement("a");
    anchor.href = url;
    if (this.data === "BEGEOID") {
      anchor.download = "BEGEOID_LIST.xlsx";
    } else if (this.data === "END_CUSTOMER_ID") {
      anchor.download = "END_CUSTOMER_LIST.xlsx";
    } else if (this.data === "INDIVIDUAL_PRODUCT_LIST") {
      anchor.download = "PRODUCT_PAYOUTS.xlsx";
    } else if (this.data === "PRODUCT_LIST") {
      anchor.download = "PRODUCT_LIST.xlsx";
    } else if (this.data === "EXCEL_MERGE") {
      anchor.download = "PRODUCT_LIST_ANY_PRODUCT.xlsx";
    } else if (this.data === "PRODUCT_SKUS") {
      anchor.download = "PRODUCT_SKUS.xlsx";
    } else if (this.data === "PRODUCT_FAMILIES") {
      anchor.download = "PRODUCT_FAMILIES.xlsx";
    } else if (this.data === "TARGETS_INDIVIDUAL") {
      anchor.download = "TARGETS_INDIVIDUAL.xlsx";
    } else if (this.data === "TARGETS_COMPANY") {
      anchor.download = "TARGETS_COMPANY.xlsx";
    } else if (this.data === "PARTICIPANT_INDIVIDUAL") {
      anchor.download = "PARTICIPANT_INDIVIDUAL.xlsx";
    } else if (this.data === "PARTICIPANT_COMPANY") {
      anchor.download = "PARTICIPANT_COMPANY.xlsx";
    } else if (this.data === "UPLOAD_COMPLETION") {
      anchor.download = "Participation Challenge Completions Upload.xlsx";
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}

@Component({
  selector: "data-list-dialog",
  templateUrl: "./data-list-dialog.html",
  styleUrls: ["./data-list-dialog.scss"],
})
export class DataListDialog {
  constructor(
    public dialogRef: MatDialogRef<DataListDialog>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
}
